<template>
    <div>
        <b-tabs v-model="activetab" pills content-class="m-0" card>
            <b-tab :title="$t('Produkter')" no-body lazy>
                <AdminProductList :data="products" product-name="monteringsstolpe" product-code="ms" @on-deleted-item="fetchMs"></AdminProductList>
            </b-tab>
            <b-tab :title="$t('Kriterier')" no-body lazy>
                <AdminMsOptionsList></AdminMsOptionsList>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import AdminProductList from "@/components/admin/AdminProductList";
    import AdminMsOptionsList from "@/components/admin/AdminMsOptionsList";
    import ApiServiceAdmin from "@/services/ApiServiceAdmin";
    export default {
        components: {
            AdminProductList,
            AdminMsOptionsList
        }, 
        data() {
            return {
                products: [],
                totalForSlug: {},
                activetab: 0
            }
        },
        methods: {
            fetchMs() {
                ApiServiceAdmin.getMs().then((response) => {
                    this.products = response.data;
                });
            },
        },
        mounted() {
            this.fetchMs();
        },
    }

</script>